import { redirect } from '@tanstack/react-router';

import { getRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard: if an administrator has switched the Memory section off (runtime config
 * `features.memory === false`), redirect away from `/memory` — so a bookmark or a deep link cannot
 * reach a section the platform has hidden, not only the nav row.
 *
 * Fail-open, like Quality's: the config loader defaults the flag to `true`, so a blip on `/v1/config`
 * leaves the route reachable rather than locking people out of their own memory.
 *
 * The per-workspace `memory` domain is deliberately NOT checked here. It needs a query the router
 * cannot run synchronously, and the page itself says so in place — a redirect on a still-loading
 * registry would bounce people out of a section they are allowed to use.
 */
export function ensureMemoryEnabled(): void {
  if (!getRuntimeConfig().features.memory) {
    throw redirect({ to: '/' });
  }
}
